module.exports = __webpack_public_path__ + "static/media/certificates.107e6f1b.svg";